<template>
  <div class="w-full h-full relative" :class="initialized ? '' : ''">
    <!-- <template v-if="userStore.authenticated"> -->

    <div v-if="choseLinkLater" class="sticky z-30 top-0 w-full col-span-full bg-turquoise-500/20 p-2 pl-4 sm:pl-8 pr-3 flex justify-between items-center border-b border-b-turquoise-500/50 backdrop-blur-lg">
      <div class="sm:flex-row flex-col flex justify-start items-start sm:items-center sm:space-x-2 mr-2 sm:mr-0">
        <p class="font-bold text-turquoise-500">Staking Disabled</p>
        <p class="text-sm text-turquoise-100">Link your Telegram and create a profile to enable staking</p>
      </div>

      <button @click="linkNow()" class="btn btn-sm bg-turquoise-500 border-turquoise-900/50 text-turquoise-1000 capitalize hover:text-white">Link Now</button>
    </div>

    <div class="modal" role="dialog" :class="needLinkProfile ? 'modal-open' : ''">
      <div class="w-full h-full flex justify-center items-center flex-col bg-black/50 backdrop-blur-md p-4">
        <div class="text-left w-full max-w-sm flex justify-between items-center mb-2" v-if="showLinkProfile">
          <div>
            <p class="uppercase text-white text-sm">Complete your Profile</p>
            <p class="text-sm text-woodsmoke-200">to unlock staking</p>
          </div>

          <button @click="linkLater()" class="btn text-red-500 btn-sm capitalize border-red-500/20">Link Later</button>
        </div>

        <div class="w-full max-w-md border border-white/10 rounded-md bg-woodsmoke-850">
          <!-- <TelegramLink @complete="linkComplete()" v-if="showLinkProfile"></TelegramLink> -->

          <div class="w-full flex justify-between p-4 items-center flex-col h-full text-center" v-if="!showLinkProfile">
            <div class="w-full flex justify-start items-center space-x-2 bg-white/5 p-2 rounded-md">
              <!-- <span class="iconify text-2xl text-white/50" data-icon="line-md:cancel"></span> -->
              <Icon name="line-md:cancel" class="text-2xl text-white/50" />

              <div class="w-full text-left">
                <p class="uppercase text-turquoise-500 tracking-widest text-xl">Staking Disabled</p>
              </div>
            </div>

            <p class="text-white pt-4">To enable staking, link your Telegram with our bot:</p>

            <div>
              <div class="w-full flex flex-col justify-center items-center pt-4">
                <div class="w-full max-w-md p-4 rounded-md border border-white/20 shadow-turquoise-900/50 shadow-2xl bg-woodsmoke-800">
                  <div class="w-full grid grid-cols-[auto_1fr_auto] justify-center items-center gap-x-4">
                    <div class="w-20 h-20 flex-shrink-0 rounded-full p-1 border border-white/20 bg-white/10">
                      <img class="w-full h-full object-cover rounded-full" src="~/assets/auth_botpic.png" alt="" />
                    </div>

                    <div class="w-full">
                      <div class="text-left">
                        <p class="text-xl text-white">Oxbull Auth Bot</p>
                        <p>@oxb_auth_bot</p>
                        <div class="flex justify-start items-center w-full mt-4">
                          <a :href="telegramUrl" target="_blank" class="btn m-0 min-h-0 lowercase h-auto text-sm bg-woodsmoke-700 p-1 px-2 rounded-md text-turquoise-500 flex justify-start items-center space-x-2 border border-white/20">
                            <p>{{ "t.me/oxb_auth_bot" }}</p>
                            <!-- <span class="iconify" data-icon="akar-icons:link"></span> -->
                            <Icon name="akar-icons:link" />
                          </a>

                          <button @click="copyLink()" class="btn btn-circle btn-sm btn-ghost text-turquoise-500 ml-1">
                            <!-- <span class="iconify" data-icon="akar-icons:copy"></span> -->
                            <Icon name="akar-icons:copy" />
                          </button>
                        </div>
                        <p class="text-sm text-woodsmoke-400 capitalize pt-1">↑ launch bot in Telegram</p>
                      </div>
                    </div>

                    <div class="hidden sm:flex justify-center items-center flex-col">
                      <div class="w-[80px] rounded-md overflow-hidden">
                        <ClientOnly>
                          <vue-qrcode :color="{ dark: '#000000ff', light: '#ffffffff' }" type="image/png" :width="80" :value="telegramUrl" />
                        </ClientOnly>
                      </div>

                      <div class="break-words text-sm text-center leading-3 pt-4">
                        <!-- <button class="btn btn-link btn-xs text-turquoise-500 text-xs capitalize">Open Telegram</button> -->
                        Tg On Mobile?
                        <br />
                        Scan to Launch
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mt-8 text-sm space-y-2 w-full max-w-md text-left mb-4">
                  <p class="text-turquoise-500 text-base">Important:</p>
                  <p>
                    ● Ensure you're interacting with the correct bot by verifying its username:
                    <span class="text-turquoise-200">@oxb_auth_bot</span>
                  </p>
                  <p>● If launching in Telegram fails, close the telegram app and retry.</p>
                  <p>● For Web3 wallets like Metamask and Trust Wallet, which block direct launches from Telegram, copy and paste the link into your browser to access manually.</p>
                </div>
              </div>
            </div>

            <!-- <div class="p-4 mt-8">
                <div class="w-full grid grid-cols-8 justify-center items-center gap-4 border p-4 border-white/10 rounded-md bg-white/5">
                  <div class="col-span-2 flex-col aspect-square flex justify-center items-center w-full">
                    <span class="iconify text-white text-3xl" data-icon="ph:wallet-fill"></span>
                    <p class="text-xs pt-2 uppercase text-woodsmoke-50">Wallet</p>
                  </div>

                  <div class="w-full flex justify-center items-center">
                    <div class="w-full h-[2px] rounded-full bg-white"></div>
                  </div>

                  <div class="col-span-2 flex-col aspect-square flex justify-center items-center w-full">
                    <span class="iconify text-white text-3xl" data-icon="ic:baseline-telegram"></span>
                    <p class="text-xs pt-2 uppercase text-woodsmoke-50">Telegram</p>
                  </div>

                  <div class="w-full flex justify-center items-center">
                    <div class="w-full h-[2px] rounded-full bg-white"></div>
                  </div>

                  <div class="col-span-2 flex-col aspect-square flex justify-center items-center w-full">
                    <span class="iconify text-white text-3xl" data-icon="iconamoon:profile-fill"></span>
                    <p class="text-xs pt-2 uppercase text-woodsmoke-50">Profile</p>
                  </div>
                </div>
              </div> -->

            <div class="w-full">
              <button @click="linkLater()" class="btn w-full bg-turquoise-500 text-turquoise-900 hover:text-white">Link Later</button>

              <!-- <button @click="linkLater()" class="btn btn-link text-red-500">Link Later</button> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <ClientOnly>
      <StakeSelectModal @complete="stakingComplete" ref="stakingModalRef" :address="$address" :accountData="accountData" :oxbBalance="oxbBalance"></StakeSelectModal>

      <StakeCompleteModal @showGroup="showGroupTour" ref="stakingCompleteModalRef" :accountData="accountData"></StakeCompleteModal>
    </ClientOnly>

    <article class="w-full h-full min-h-screen">
      <section class="bg-gradient-to-b from-limed-spruce-900 to-transparent">
        <div class="w-full pl-4 pt-10 mb-4">
          <NuxtLink to="/app" class="bg-turquoise-500/20 border-turquoise-900 text-turquoise-500 shadow-xl rounded-full btn btn-circle btn-sm">
            <!-- <span class="iconify" data-icon="mdi:arrow-left"></span> -->
            <Icon name="mdi:arrow-left" />
          </NuxtLink>
        </div>

        <div class="w-full">
          <div class="p-4">
            <div class="flex justify-start items-center">
              <h1 class="text-white text-3xl">Staking & Qualification</h1>
              <button id="staking_tour" @click="startTour()" class="btn btn-xs btn-square ml-2 mb-1 text-lg bg-gradient-to-br from-turquoise-500/50 to-turquoise-900/50 text-turquoise-500">
                <!-- <span class="iconify" data-icon="memory:help"></span> -->
                <Icon name="memory:help" />
              </button>
            </div>

            <a href="https://oxbull.medium.com/guide-to-oxbull-staking-c3e7713fab21" target="_blank" id="staking_medium_details" class="btn btn-link p-0 m-0 text-turquoise-500 capitalize">Read Medium</a>
          </div>

          <div class="w-full flex justify-between items-center space-x-4 pl-4 pb-4 pr-2">
            <p class="text-base text-woodsmoke-100">Stake OXI tokens to get qualifications to contribute.</p>

            <template v-if="!$accessToken">
              <div v-if="!$address" class="flex flex-col justify-center items-center">
                <p class="mb-2 text-sm opacity-80 pr-2">Connect Wallet to Proceed</p>

                <WalletModal>
                  <button class="btn bg-turquoise-500 rounded-full sm:text-xl text-lg sm:px-8 px-4 font-semibold hover:text-white border-transparent shadow-turquoise-500/20 text-turquoise-900 mb-2">
                    <span>Connect Wallet</span>
                  </button>
                </WalletModal>
              </div>

              <!-- <div v-if="address" class="flex flex-col justify-center items-center">
                <p class="mb-2 text-sm opacity-80 pr-2">Sign to Login and Stake</p>

                <button @click="userStore.reauth()" class="btn bg-turquoise-500 rounded-full sm:text-xl text-lg sm:px-8 px-4 font-semibold hover:text-white border-transparent shadow-turquoise-500/20 text-turquoise-900 mb-2">
                  <span>Sign Now</span>
                </button>
              </div> -->
            </template>
            <template v-else>
              <button v-if="$chainId == 8453" :disabled="!(accountData?.stakes?.amount >= 0 || needLinkProfile)" id="staking_cta_button" @click="toggleStakingModal()" class="btn bg-turquoise-500 rounded-full sm:text-xl text-lg sm:px-8 px-4 tracking-widest font-semibold hover:text-white border-transparent shadow-turquoise-500/20 text-turquoise-900 mb-2">
                <template v-if="accountData?.stakes?.amount >= 0">
                  <span>Stake</span>
                </template>
                <template v-else>
                  <div class="flex justify-center items-center space-x-2">
                    <!-- <span class="iconify" data-icon="eos-icons:loading"></span> -->
                    <Icon name="eos-icons:loading" />
                    <p>Loading</p>
                  </div>
                </template>
              </button>

              <div class="text-right flex flex-col justify-end items-end" v-else>
                <p class="mb-2 text-sm opacity-80 pr-2">Switch to Base Chain to Stake</p>
                <button @click="switchToBase()" class="btn bg-turquoise-500 rounded-full sm:text-xl text-lg sm:px-8 px-4 font-semibold hover:text-white border-transparent shadow-turquoise-500/20 text-turquoise-900 mb-2">
                  <span>Switch to BASE</span>
                </button>
              </div>
            </template>
          </div>
        </div>

        <div v-if="$accessToken && initialized" id="staking_status" class="p-4 sm:p-0">
          <div class="sm:bg-transparent bg-white/5 rounded-xl">
            <div class="w-full grid sm:grid-cols-3 grid-cols-1 justify-start items-start sm:border-y sm:border-y-white/20">
              <div class="col-span-full border-b border-b-white/20 p-2 px-4 sm:pr-2 w-full flex justify-between items-center">
                <p class="sm:block hidden text-sm text-woodsmoke-50">Showing data of: {{ $address }}</p>
                <p class="sm:hidden text-sm text-woodsmoke-50">Connected: {{ $address.substring(0, 15) }}...</p>

                <button @click="$deauth()" class="sm:mr-0 -mr-2 btn btn-xs text-sm btn-link text-red-500 capitalize">Disconnect</button>
              </div>

              <div id="staking_qualification_list" class="flex flex-col justify-between items-between w-full h-full row-span-2">
                <p class="mb-2 text-turquoise-500 pl-4 pt-4">Your Qualifactions</p>

                <div class="w-full h-full flex flex-col justify-end items-between">
                  <div v-for="row in qualification_display_list" class="grid grid-cols-4 text-left justify-center items-center px-4 last:border-b-0 border-b border-b-white/10 pb-2 mb-2">
                    <div class="col-span-3 text-white">{{ row.label }}</div>
                    <div class="text-turquoise-300 text-right text-sm">{{ row.value }}</div>
                  </div>

                  <div class="text-white h-full w-full flex justify-start items-center pl-4" v-if="qualification_display_list.length == 0">
                    <p>You have no qualifications</p>
                  </div>
                </div>
              </div>

              <div id="staking_qualified_groups" class="w-full h-full flex flex-col justify-center items-center row-span-2 sm:border-x sm:border-x-white/20 sm:border-y-0 border-y border-y-white/20">
                <p class="mb-2 text-turquoise-500 p-4 w-full text-left">Your Groups</p>

                <div class="w-full h-full flex flex-col justify-end items-end">
                  <div v-for="group in group_data_display" class="w-full flex justify-between items-center px-4 last:border-b-0 border-b border-b-white/10 pb-2 mb-2">
                    <div>
                      <p>
                        <span v-if="group.exclusive">✨</span>
                        {{ group.label }}
                      </p>
                    </div>

                    <a :href="group.url" target="_blank" class="btn btn-link text-turquoise-500 btn-xs text-sm m-0 p-0 min-h-0 h-auto capitalize font-normal">Join</a>
                  </div>
                </div>
              </div>

              <div id="staking_oxb_staked" class="w-full h-full p-4 flex flex-col justify-between items-start border-b-white/20 border-b">
                <div class="w-full flex justify-between items-center">
                  <p class="text-turquoise-500">OXI Token Staked</p>
                </div>
                <div v-if="accountData" class="w-full flex justify-between items-center">
                  <div>

                    <p class="sm:font-thin text-white">
                      <span class="sm:text-2xl text-xl">{{ _splitNumberByDot(Number(accountData?.stakes?.amount || 0).toFixed(2)).integer }}</span>
                      .
                      <span class="text-woodsmoke-100">{{ _splitNumberByDot(Number(accountData?.stakes?.amount || 0).toFixed(2)).decimal }}</span>
                      OXI
                    </p>

                    <p v-if="unstaked">(unstaked)</p>
                  </div>

                  <button id="staking_oxb_staked_refresh" class="btn btn-circle btn-xs bg-woodsmoke-800 ring ring-woodsmoke-400/20 border-none">
                    <!-- <span class="iconify text-lg text-woodsmoke-300" data-icon="tabler:reload"></span> -->
                    <Icon name="tabler:reload" class="text-woodsmoke-300 text-lg" />
                  </button>
                </div>
                <div v-else class="w-full flex justify-start items-center space-x-2">
                  <!-- <span class="iconify text-lg" data-icon="eos-icons:loading"></span> -->
                  <Icon name="eos-icons:loading" class="text-lg" />
                  <p class="sm:text-2xl text-xl sm:font-thin text-white">Loading...</p>
                </div>
              </div>

              <div id="staking_oxb_balance" class="w-full h-full flex flex-col justify-between items-start p-4">
                <div class="w-full flex justify-between items-center">
                  <p class="text-turquoise-500">OXI Token in Wallet</p>
                </div>

                <div v-if="$chainId == 8453" class="w-full flex justify-between items-end">
                  <!-- <p class="sm:text-2xl text-xl sm:font-thin text-white">{{ Number(oxbBalance).toFixed(2) }} OXI</p> -->
                  <p class="sm:font-thin text-white">
                    <span class="sm:text-2xl text-xl">{{ _splitNumberByDot(Number(oxbBalance).toFixed(2)).integer }}</span>
                    .
                    <span class="text-woodsmoke-100">{{ _splitNumberByDot(Number(oxbBalance).toFixed(2)).decimal }}</span>
                    OXI
                  </p>

                  <a :href="buy_oxb_url" target="_blank" id="staking_buy_oxb" class="text-turquoise-500 sm:text-lg capitalize underline">Buy OXI</a>
                </div>
                <div class="w-full flex justify-between items-center pt-2" v-else>
                  <p class="sm:font-thin text-white">Connect to Base chain to see your OXI balance</p>

                  <button @click="switchToBase()" class="btn bg-turquoise-500 text-turquoise-1000 border-none min-h-0 p-2 px-3 h-auto hover:text-white">Switch</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <template v-if="initialized || $address">
        <section id="staking_oxb_menu">
          <div class="w-full p-8">
            <p class="uppercase tracking-widest text-xs">Token Staking Route</p>
            <p class="text-3xl text-white font-light">OXI Token Staking</p>
          </div>

          <div class="sm:px-8 px-4">
            <div class="w-full sm:grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 sm:gap-4 space-y-4 sm:space-y-0">
              <div :id="`oxb_stake_menu_card_${i + 1}`" v-for="(_data, i) in OxbData" :class="['w-full border bg-white/5 shadow-xl rounded-md grid grid-cols-1 grid-rows-[auto_1fr_auto] overflow-hidden', get_stake_own(i) > 0 ? 'border-turquoise-500 shadow-turquoise-500/5' : 'border-white/10 shadow-black/5 ']">
                <div class="w-full grid grid-cols-5 bg-white/5 p-2 px-4 pr-2 uppercase text-xs justify-center items-center">
                  <div class="col-span-2 text-left tracking-widest">
                    <p>You Own</p>
                  </div>

                  <div class="flex justify-end items-center text-right font-mono col-span-3">
                    <div class="p-1 rounded-md bg-white/20">{{ get_stake_own(i) }}</div>
                  </div>
                </div>

                <div class="w-full h-full flex flex-col justify-between items-center">
                  <div class="w-full flex flex-col justify-center items-center -mt-4">
                    <div class="w-[100px] flex flex-col justify-center items-center mb-4">
                      <img class="w-full object-contain mb-4" :src="_data.image" alt="" />
                      <div class="text-center text-xl uppercase tracking-widest font-light">Tier {{ i + 1 }}</div>
                    </div>

                    <div class="w-full px-4 border-y border-y-white/10 py-2 -mt-2">
                      <p class="text-3xs uppercase tracking-widest text-woodsmoke-200">requirement</p>
                      <p class="text-sm">{{ _data.requirements }}</p>
                    </div>
                  </div>

                  <div class="w-full p-4 pb-2 h-full flex flex-col justify-between items-start">
                    <div class="">
                      <p class="text-xs text-turquoise-500">Key Features</p>

                      <div class="text-sm" v-html="_data.features"></div>
                    </div>

                    <div class="w-full flex justify-end items-center">
                      <a href="https://oxbull.medium.com/guide-to-oxbull-staking-c3e7713fab21" target="_blank" class="btn capitalize text-turquoise-500 text-xs btn-xs">Read Full Details</a>
                    </div>
                  </div>
                </div>

                <div class="w-full flex justify-center items-center p-2 border-t border-t-white/10">
                  <template v-if="accountData">
                    <template v-if="i == 2">
                      <!-- oxb_staked_eth -->
                      <button v-if="!disableTier3" @click="stakeForOxbTier(_data.token)" class="btn bg-white/10 border-turquoise-500/20 tracking-widest text-turquoise-500 w-full shadow-xl shadow-black/20">Stake {{ _data.token }} OXI</button>
                      <button v-else disabled class="btn bg-white/10 tracking-widest disabled:text-red-500 w-full capitalize">Unavailable.</button>
                    </template>
                    <template v-else>
                      <button @click="stakeForOxbTier(_data.token)" :id="`stake_button_${i + 1}`" class="btn bg-white/10 border-turquoise-500/20 tracking-widest text-turquoise-500 w-full shadow-xl shadow-black/20">Stake {{ _data.token }} OXI</button>
                    </template>
                  </template>
                  <template v-else>
                    <div v-if="$accessToken" class="btn bg-white/10 border-turquoise-500/20 tracking-widest text-turquoise-500 w-full shadow-xl shadow-black/20">
                      <Icon name="eos-icons:loading" class="text-lg" />
                    </div>

                    <div v-else @click="stakeForOxbTier(_data.token)" class="btn bg-white/10 border-turquoise-500/20 tracking-widest text-turquoise-500 w-full shadow-xl shadow-black/20">
                      <button :id="`stake_button_${i + 1}`">Stake {{ _data.token }} OXI</button>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </section>
<!--
        <section>
          <div class="w-full p-8">
            <p class="uppercase tracking-widest text-xs">For Tier 2 & Tier 3</p>
            <p class="text-3xl text-white font-light">Private Sale Pass</p>
          </div>

          <div class="sm:px-8 px-4">
            <div class="w-full sm:grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 sm:gap-4 space-y-4 sm:space-y-0">
              <div v-for="i in 2" :class="['w-full border  bg-white/5 shadow-xl rounded-md grid grid-cols-1 grid-rows-[auto_1fr_auto] overflow-hidden', showPspActive(i) ? 'border-turquoise-500 shadow-turquoise-500/5' : 'border-white/10 shadow-black/5 ']">
                <div class="w-full bg-white/5 p-2 px-4 uppercase text-xs">
                  <template v-if="qualification_data?.oxb_psp">
                    <template v-if="showPspActive(i)">
                      <div class="flex justify-start items-center space-x-2">
                        <Icon name="mdi:check-bold" class="text-green-500" />
                        <p>Activated</p>
                      </div>
                    </template>
                    <template v-else>
                      <div class="flex justify-start items-center space-x-2">
                        <Icon name="mdi:close-bold" class="text-red-500" />
                        <p>Not Activated</p>
                      </div>
                    </template>
                  </template>

                  <template v-else>
                    <p class="tracking-wide">Not Active</p>
                  </template>
                </div>

                <div class="w-full h-full flex flex-col justify-between items-center">
                  <div class="w-full flex flex-col justify-center items-center">
                    <div class="w-full px-4 py-2">
                      <img class="w-[5rem] h-[5rem] mb-2 object-contain" :src="`https://oxbull-presale.s3.amazonaws.com/tier${i + 1}.svg`" alt="" />
                      <h2 class="uppercase tracking-widest font-light">Tier {{ i + 1 }} Private Sale Pass</h2>
                    </div>

                    <div class="w-full px-4 border-y border-y-white/10 py-2">
                      <div class="text-left">
                        <p class="text-3xs uppercase tracking-widest text-woodsmoke-200">requirement</p>
                        <p class="text-sm">Stake as Tier {{ i + 1 }} for 365 days</p>
                      </div>
                    </div>
                  </div>

                  <div class="w-full p-4 pb-2">
                    <div class="">
                      <p class="text-xs text-turquoise-500">Key Features</p>

                      <div class="text-sm">With this pass you will get access to contribute in Private Sale. Once activated, your tokens are subjected to a 365 days timelock.</div>
                    </div>

                    <div class="w-full flex justify-end items-center">
                      <a href="https://oxbull.medium.com/expanding-opportunities-introducing-the-private-sale-pass-for-tier-2-and-tier-3-holders-5d9577341351" target="_blank" class="btn capitalize text-turquoise-500 text-xs btn-xs">Read Full Details</a>
                    </div>
                  </div>
                </div>

                <div class="w-full flex justify-center items-center p-2 border-t border-t-white/10">
                  <template v-if="qualification_data?.oxb_stake_tier1 > 0">
                    <div class="w-full flex justify-between items-center p-2">
                      <p class="text-red-500 font-semibold">Not available for Tier One</p>

                      <ClientOnly>
                        <VDropdown>
                          <button class="btn btn-circle btn-sm bg-white/10 text-turquoise-500">?</button>

                          <template #popper>
                            <div class="text-woodsmoke-50 border border-white/50 p-2 rounded-md">
                              If your wallet have Tier 1, along with Tier 2 or Tier 3:
                              <br />
                              You need to transfer your Tier 2 or Tier 3 to another wallet to activate Private Sale Pass.
                            </div>
                          </template>
                        </VDropdown>
                      </ClientOnly>
                    </div>
                  </template>
                  <template v-else>

                    <template v-if="alreadyHaveDifferentPsp(i)">
                      <div class="btn bg-white/10 tracking-widest text-white/50 w-full">
                      Unavailable
                      </div>
                    </template>
                    <template v-else>
                      <router-link v-if="!qualification_data?.oxb_psp" to="/app/private-sale-pass" class="btn bg-white/10 border-turquoise-500/20 tracking-widest text-turquoise-500 w-full shadow-xl shadow-black/20">Activate</router-link>
  
                      <div class="btn bg-white/10 border-turquoise-500/20 tracking-widest text-turquoise-500 w-full" v-else>
                        Already Activated
                        </div>

                    </template>
                    
                  </template>
                </div>
              </div>
            </div>
          </div>
        </section>
-->
        <section v-if="showAllOptions">
          <div class="w-full p-8">
            <p class="uppercase tracking-widest text-xs">[KWAI]</p>
            <p class="text-3xl text-white font-light">Kwai Token Staking</p>
          </div>

          <div class="sm:px-8 px-4">
            <div class="w-full sm:grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 sm:gap-4 space-y-4 sm:space-y-0">
              <div v-for="(_data, i) in kwaiData" class="w-full border border-white/10 bg-white/5 shadow-xl shadow-black/5 rounded-md grid grid-cols-1 grid-rows-[auto_1fr_auto] overflow-hidden">
                <div class="w-full grid grid-cols-5 bg-white/5 p-2 px-4 uppercase text-xs justify-center items-center">
                  <div class="col-span-2 text-left tracking-widest">
                    <p>You Own</p>
                  </div>

                  <p class="text-right font-mono col-span-3">0</p>
                </div>

                <div class="w-full h-full flex flex-col justify-between items-center">
                  <div class="w-full flex flex-col justify-center items-center -mt-4">
                    <div class="w-[100px] h-[200px]">
                      <img class="w-full h-full object-contain" :src="_data.image" alt="" />
                    </div>
                    <div class="w-full flex justify-between items-center px-4 border-y border-y-white/10 py-2 -mt-2">
                      <h2 class="text-xl uppercase tracking-widest font-light">Tier {{ i + 1 }}</h2>
                      <!-- <div class="p-1 px-2 rounded-md bg-black/20 border border-turquoise-500/20 text-turquoise-500">8000 OXI</div> -->

                      <div class="text-right">
                        <p class="text-3xs uppercase tracking-widest text-woodsmoke-200">requirement</p>
                        <p class="text-sm">{{ _data.requirements }}</p>
                      </div>
                    </div>
                  </div>

                  <div class="w-full h-full p-4 pb-2 flex flex-col justify-between items-start">
                    <div class="">
                      <p class="text-xs text-turquoise-500">Key Features</p>

                      <div class="text-sm" v-html="_data.features"></div>
                    </div>

                    <div class="w-full flex justify-end items-center">
                      <a href="https://kwailabs.medium.com/introducing-kwai-updated-14th-jan-2023-bsc-relaunch-326acf4c3719" target="_blank" class="btn capitalize text-turquoise-500 text-xs btn-xs">Read Full Details</a>
                    </div>
                  </div>
                </div>

                <div class="w-full flex justify-center items-center p-2 border-t border-t-white/10">
                  <a href="https://kwailabs.com/app/stake" target="_blank" class="btn bg-white/10 border-turquoise-500/20 tracking-widest text-turquoise-500 w-full shadow-xl shadow-black/20">Stake in kwailabs.com</a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section v-if="showAllOptions">
          <div class="w-full p-8">
            <p class="uppercase tracking-widest text-xs">[KWAI]</p>
            <p class="text-3xl text-white font-light">Kwai TQ NFT</p>
          </div>

          <div class="sm:px-8 px-4">
            <div class="w-full sm:grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 sm:gap-4 space-y-4 sm:space-y-0">
              <div v-for="(_data, i) in kwaiNftData" class="w-full border border-white/10 bg-white/5 shadow-xl shadow-black/5 rounded-md grid grid-cols-1 grid-rows-[auto_1fr_auto] overflow-hidden">
                <div class="w-full grid grid-cols-5 bg-white/5 p-2 px-4 uppercase text-xs justify-center items-center">
                  <div class="col-span-2 text-left tracking-widest">
                    <p>You Own</p>
                  </div>

                  <p class="text-right font-mono col-span-3">0</p>
                </div>

                <div class="w-full h-full flex flex-col justify-between items-center">
                  <div class="w-full flex flex-col justify-center items-center -mt-4">
                    <div class="w-[100px] h-[200px]">
                      <img class="w-full h-full object-contain" :src="_data.image" alt="" />
                    </div>
                    <div class="w-full flex justify-between items-center px-4 border-y border-y-white/10 py-2 -mt-2">
                      <h2 class="text-xl uppercase tracking-widest font-light">Tier {{ i + 1 }}</h2>
                      <!-- <div class="p-1 px-2 rounded-md bg-black/20 border border-turquoise-500/20 text-turquoise-500">8000 OXI</div> -->

                      <div class="text-right">
                        <p class="text-3xs uppercase tracking-widest text-woodsmoke-200">requirement</p>
                        <p class="text-sm">{{ _data.requirements }}</p>
                      </div>
                    </div>
                  </div>

                  <div class="w-full h-full p-4 pb-2 flex flex-col justify-between items-start">
                    <div class="">
                      <p class="text-xs text-turquoise-500">Key Features</p>

                      <div class="text-sm" v-html="_data.features"></div>
                    </div>

                    <div class="w-full flex justify-end items-center">
                      <!-- <button class="btn capitalize text-turquoise-500 text-xs btn-xs">Read Full Details</button> -->

                      <a href="https://kwailabs.medium.com/introducing-the-private-sale-pass-for-tier-2-and-tier-3-holders-2435db753abe" target="_blank" class="btn capitalize text-turquoise-500 text-xs btn-xs">Read Full Details</a>
                    </div>
                  </div>
                </div>

                <div class="w-full flex justify-center items-center p-2 border-t border-t-white/10">
                  <!-- <button class="btn bg-white/10 border-turquoise-500/20 tracking-widest text-turquoise-500 w-full shadow-xl shadow-black/20">Stake For Tier {{ i }}</button> -->

                  <a href="https://kwailabs.com/app/stake" target="_blank" class="btn bg-white/10 border-turquoise-500/20 tracking-widest text-turquoise-500 w-full shadow-xl shadow-black/20">Stake in kwailabs.com</a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section v-if="showAllOptions">
          <div class="w-full p-8">
            <p class="uppercase tracking-widest text-xs">[KWAI]</p>
            <p class="text-3xl text-white font-light">Private Sale Pass</p>
          </div>

          <div class="sm:px-8 px-4">
            <div class="w-full sm:grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 sm:gap-4 space-y-4 sm:space-y-0">
              <div v-for="(_data, i) in kwaiPSPTokenData" class="w-full border border-white/10 bg-white/5 shadow-xl shadow-black/5 rounded-md grid grid-cols-1 grid-rows-[auto_1fr_auto] overflow-hidden">
                <div class="w-full grid grid-cols-5 bg-white/5 p-2 px-4 uppercase text-xs justify-center items-center">
                  <div class="col-span-2 text-left tracking-widest">
                    <p>You Own</p>
                  </div>

                  <p class="text-right font-mono col-span-3">0</p>
                </div>

                <div class="w-full h-full flex flex-col justify-between items-center">
                  <div class="w-full flex flex-col justify-center items-center">
                    <div class="w-full px-4 border-y border-y-white/10 py-4">
                      <img class="w-[5rem] h-[5rem] mb-2 object-contain" :src="_data.image" alt="" />
                      <h2 class="tracking-widest font-light">Kwai Staking Tier {{ i + 1 }} Private Sale Pass</h2>
                      <!-- <div class="p-1 px-2 rounded-md bg-black/20 border border-turquoise-500/20 text-turquoise-500">8000 OXI</div> -->

                      <!-- <div class="text-right">
                      <p class="text-3xs uppercase tracking-widest text-woodsmoke-200">requirement</p>
                      <p class="text-sm">Staked as Tier 2 for 1 year</p>
1                    </div> -->
                    </div>

                    <div class="w-full px-4 border-y border-y-white/10 py-2">
                      <!-- <h2 class=" uppercase tracking-widest font-light">Tier {{ i+1 }}<br>Private Sale Pass</h2> -->
                      <!-- <div class="p-1 px-2 rounded-md bg-black/20 border border-turquoise-500/20 text-turquoise-500">8000 OXI</div> -->

                      <div class="text-left">
                        <p class="text-3xs uppercase tracking-widest text-woodsmoke-200">requirement</p>
                        <p class="text-sm">Stake KWAI as Tier {{ i + 1 }} for 1 year</p>
                      </div>
                    </div>
                  </div>

                  <div class="w-full p-4 pb-2">
                    <div class="">
                      <p class="text-xs text-turquoise-500">Key Features</p>

                      <div class="text-sm">With this pass you will get access to contribute in Private Sale. Once activated, your tokens are subjected to a 365 days timelock.</div>
                    </div>

                    <div class="w-full flex justify-end items-center">
                      <a href="https://kwailabs.medium.com/introducing-the-private-sale-pass-for-tier-2-and-tier-3-holders-2435db753abe" target="_blank" class="btn capitalize text-turquoise-500 text-xs btn-xs">Read Full Details</a>
                    </div>
                  </div>
                </div>

                <div class="w-full flex justify-center items-center p-2 border-t border-t-white/10">
                  <!-- <button class="btn bg-white/10 border-turquoise-500/20 tracking-widest text-turquoise-500 w-full shadow-xl shadow-black/20">Activate</button> -->

                  <a href="https://kwailabs.com/app/stake" target="_blank" class="btn bg-white/10 border-turquoise-500/20 tracking-widest text-turquoise-500 w-full shadow-xl shadow-black/20">Activate in kwailabs.com</a>
                </div>
              </div>

              <div v-for="(_data, i) in kwaiPSPNftData" class="w-full border border-white/10 bg-white/5 shadow-xl shadow-black/5 rounded-md grid grid-cols-1 grid-rows-[auto_1fr_auto] overflow-hidden">
                <div class="w-full grid grid-cols-5 bg-white/5 p-2 px-4 uppercase text-xs justify-center items-center">
                  <div class="col-span-2 text-left tracking-widest">
                    <p>You Own</p>
                  </div>

                  <p class="text-right font-mono col-span-3">0</p>
                </div>

                <div class="w-full h-full flex flex-col justify-between items-center">
                  <div class="w-full flex flex-col justify-center items-center">
                    <div class="w-full px-4 border-y border-y-white/10 py-4">
                      <img class="w-[5rem] h-[5rem] mb-2 object-contain" :src="_data.image" alt="" />
                      <h2 class="tracking-widest font-light">Kwai TQ NFT Tier {{ i + 1 }} Private Sale Pass</h2>
                      <!-- <div class="p-1 px-2 rounded-md bg-black/20 border border-turquoise-500/20 text-turquoise-500">8000 OXI</div> -->

                      <!-- <div class="text-right">
                      <p class="text-3xs uppercase tracking-widest text-woodsmoke-200">requirement</p>
                      <p class="text-sm">Staked as Tier 2 for 1 year</p>
                    </div> -->
                    </div>

                    <div class="w-full px-4 border-y border-y-white/10 py-2">
                      <!-- <h2 class=" uppercase tracking-widest font-light">Tier {{ i+1 }}<br>Private Sale Pass</h2> -->
                      <!-- <div class="p-1 px-2 rounded-md bg-black/20 border border-turquoise-500/20 text-turquoise-500">8000 OXI</div> -->

                      <div class="text-left">
                        <p class="text-3xs uppercase tracking-widest text-woodsmoke-200">requirement</p>
                        <p class="text-sm">Stake NFT as Tier {{ i + 1 }} for 1 year</p>
                      </div>
                    </div>
                  </div>

                  <div class="w-full p-4 pb-2">
                    <div class="">
                      <p class="text-xs text-turquoise-500">Key Features</p>

                      <div class="text-sm">With this pass you will get access to contribute in Private Sale. Once activated, your NFT are subjected to a 365 days timelock</div>
                    </div>

                    <div class="w-full flex justify-end items-center">
                      <button class="btn capitalize text-turquoise-500 text-xs btn-xs">Read Full Details</button>
                    </div>
                  </div>
                </div>

                <div class="w-full flex justify-center items-center p-2 border-t border-t-white/10">
                  <a href="https://kwailabs.com/app/stake" target="_blank" class="btn bg-white/10 border-turquoise-500/20 tracking-widest text-turquoise-500 w-full shadow-xl shadow-black/20">Activate in kwailabs.com</a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- <section class="w-full flex justify-start px-8 items-center pt-8">
          <button id="staking_toggle_options" @click="showAllOptions = !showAllOptions" class="btn bg-woodsmoke-800 capitalize text-turquoise-500 font-medium">{{ showAllOptions ? "Hide full options" : "Show full options" }}</button>
        </section> -->
      </template>

      <template v-else>
        <div class="w-full mt-12 sm:px-8 px-4 sm:grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 sm:gap-4 space-y-4 sm:space-y-0">
          <div v-for="i in 6" class="w-full h-[30rem] bg-white/5 rounded-md border border-white/10 skeleton"></div>
        </div>
      </template>

      <div class="h-20 w-full"></div>

      <HeadlessTransitionRoot as="template" :show="showFirstTour">
        <HeadlessDialog as="div" class="relative z-10" @close="showFirstTour = false">
          <HeadlessTransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
            <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </HeadlessTransitionChild>

          <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <HeadlessTransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                <HeadlessDialogPanel class="relative transform overflow-hidden rounded-lg bg-woodsmoke-850 px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
                  <div class="text-center">
                    <div class="w-full flex justify-center items-center">
                      <img class="h-[200px]" src="@/assets/hello_bui.png" alt="" />
                    </div>
                    <h1 class="text-xl py-4 text-white">Welcome to OXB Staking!</h1>
                    <p>It seems like it's your first time here! Do you want to get a quick tour on the staking page?</p>
                  </div>
                  <div class="mt-5 sm:mt-6 grid grid-cols-2 justify-center items-center gap-4">
                    <div @click="showFirstTour = false" class="btn btn-ghost w-full text-red-500">Close</div>
                    <button @click="startFirstTour()" class="btn bg-turquoise-500 text-turquoise-900 border-none">Start Tour</button>
                  </div>
                </HeadlessDialogPanel>
              </HeadlessTransitionChild>
            </div>
          </div>
        </HeadlessDialog>
      </HeadlessTransitionRoot>

      <HeadlessTransitionRoot as="template" :show="showRestakeModal">
        <HeadlessDialog as="div" class="relative z-10" @close="showRestakeModal = false">
          <HeadlessTransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
            <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </HeadlessTransitionChild>

          <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <HeadlessTransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                <HeadlessDialogPanel class="relative transform overflow-hidden rounded-lg bg-woodsmoke-850 px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
                  <div class="text-center">
                    <h1 class="text-xl py-4 text-white">You have unstaked OXI</h1>
                    <p>
                      To resume staking, you need to
                      <span class="text-white">restake your OXI tokens</span>
                      . Restaking tokens have no penalty, and will reset your withdrawal timelock.
                    </p>
                  </div>
                  <div class="mt-5 sm:mt-6 grid grid-cols-2 justify-center items-center gap-4">
                    <div @click="showRestakeModal = false" class="btn btn-ghost w-full text-red-500">Cancel</div>
                    <button @click="restakeOxb()" class="btn bg-turquoise-500 text-turquoise-900 border-none">Restake</button>
                  </div>
                </HeadlessDialogPanel>
              </HeadlessTransitionChild>
            </div>
          </div>
        </HeadlessDialog>
      </HeadlessTransitionRoot>
    </article>

    <!--<div v-if="!initialized" class="w-full h-full absolute left-0 top-0 bg-black/50 backdrop-blur-md overflow-hidden z-50">
        <div class="w-full h-full flex flex-col justify-center items-center space-y-4">
          <!~~ <span class="iconify text-4xl" data-icon="eos-icons:loading"></span> ~~>
          <Icon name="eos-icons:loading" class="text-4xl" />
          <p>Loading</p>
        </div>
      </div>-->
    <!-- </template> -->

    <!--    <template v-else>
      <div class="w-full h-full flex justify-center items-center flex-col font-light text-center px-8">
        <h1 class="text-3xl">Connect Wallet to Proceed</h1>

        <WalletModal>
          <button class="btn bg-turquoise-600 mt-4 text-black hover:text-white">Connect Wallet</button>
        </WalletModal>

        <div class="pt-12">
          <NuxtLink to="/app">
            <button class="btn btn-link text-red-500">return to home</button>
          </NuxtLink>
        </div>
      </div>
    </template>-->
  </div>
</template>

<script setup>
definePageMeta({
  layout: "app",
  name: "stake",
});

useHead({
  title: "Oxbull | Stake",
  meta: [
    { name: "title", content: "Oxbull | Stake" },
    { name: "description", content: "Engage with our stake page to qualify for IDOs and earn OXB. Stake strategically for exclusive project access and enjoy consistent token rewards." },
  ],
  htmlAttrs: { lang: "en" },
});

import { useUserStore } from "~/stores/user.js";
const userStore = useUserStore();

import { OXB_V2_ADDRESS, STAKE_ADDRESS } from "~/wagmiConfig.js";
import { getAccount, watchConnections, getBalance, switchChain, writeContract, waitForTransactionReceipt } from "@wagmi/core";
import { formatEther } from "viem";
import { stakeABI } from "~/components/Stake/stakeConstants.js";

import { queryNoCache } from "~/apollo";
import { gql } from "@apollo/client/core";

import { createClient } from "@supabase/supabase-js";

import { OxbData, kwaiData, kwaiNftData, kwaiPSPTokenData, kwaiPSPNftData, qualification_label, group_data, buy_oxb_url } from "~/components/Stake/stakeConstants.js";

import { driver } from "driver.js";
import "driver.js/dist/driver.css";

import VueQrcode from "vue-qrcode";

// const address = ref("");
// const chainId = ref("");
const accountData = ref(null);

const toast = useToast();

const _toast = (param) => {
  toast.add({
    ...param,
    ui: {
      strategy: "override",
      icon: {
        base: "flex-shrink-0 w-5 h-5 mt-0.5",
        color: "text-{color}-500 dark:text-{color}-400",
      },
      background: "bg-woodsmoke-800/50 backdrop-blur-md",
      container: "border border-turquoise-500/20 relative overflow-hidden",
      title: "text-turquoise-500 text-base",
      description: "text-white text-sm",
    },
  });
};

// Link Controls
const showLinkProfile = ref(false);
const needLinkProfile = ref(false);
const choseLinkLater = ref(false);

// Link Logics

const telegramUrl = "tg://resolve?domain=oxb_auth_bot&start=auth";
import copy from "copy-to-clipboard";

const copyLink = () => {
  copy(telegramUrl);
  _toast({
    id: "migrate",
    title: "Copied!",
    description: "Link copied to clipboard",
  });
};

const linkLater = () => {
  needLinkProfile.value = false;
  choseLinkLater.value = true;
};

const linkNow = () => {
  needLinkProfile.value = true;
};

// For UI
const initialized = ref(false); // Entire thing loading flag
const qualification_display_list = ref([]); // list of qualification to display on top left
const group_data_display = ref([]); // list of group data to display on center
const showAllOptions = ref(false); // show all options or not (KWAI)

// Modal Controls
const stakingModalRef = ref(null);

// The controlling data structure
const qualification_data = ref({
  oxb_stake_tier1: 0,
  oxb_stake_tier2: 0,
  oxb_stake_tier3: 0,
  oxb_amount: 0,
  kwai_stake_tier1: 0,
  kwai_stake_tier2: 0,
  kwai_stake_tier3: 0,
  kwai_nft_tier1: 0,
  kwai_nft_tier2: 0,
  kwai_nft_tier3: 0,
  oxb_psp: false,
  kwai_psp: false,
});
// If the user linked their wallet, this will be populated
const linked_user_data = ref(null);
const userState = useState('user')

const { $address, $chainId, $wagmiConfig, $accessToken, $userData, $fetchUser } = useNuxtApp();



// const unwatch = watchConnections(config, {
//   onChange(data) {
//     if (data) {
//       let _account = getAccount(config);
//       chainId.value = _account.chainId;
//       address.value = _account.address;
//     } else {
//       address.value = null;
//     }

//     supabase = false;

//     renderView();
//   },
// });

// const unsub = userStore.$subscribe((state) => {
//   renderView();
// });

// onUnmounted(() => {
//   unwatch();
//   unsub();
// });

// watch($address, () => {
//   renderView();
// })

// watch($chainId, () => {
//   renderView();
// })

watch($accessToken, () => {
  renderView();
  if($address.value){
    posthogStore.identifyUser($address.value, {
      address: $address.value
    });
  }
})

import { usePosthogStore } from "~/stores/posthogStore";
const posthogStore = usePosthogStore();

onMounted(() => {
  // let _account = getAccount(config);
  // chainId.value = _account.chainId;
  // address.value = _account.address;
  posthogStore.initPosthog();

  if($address.value){
    posthogStore.identifyUser($address.value, {
      address: $address.value
    });
  }
  renderView();
});

const oxbBalance = ref(0);
let supabase;
let uqSub = false;
let luSub = false;

// const supabaseUrl = "https://vhtnfbodfxjaxxvusluo.supabase.co";
// const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZodG5mYm9kZnhqYXh4dnVzbHVvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDQ3NzU4MDQsImV4cCI6MjAyMDM1MTgwNH0.ul_m49651IbclnnV62eBLZLwvAtz_qHUQsiYMkxoDBg";
const { SUPABASE_KEY, SUPABASE_URL } = useRuntimeConfig().public;
const supabaseUrl = SUPABASE_URL;
const supabaseKey = SUPABASE_KEY;


const fetchAccount = () => {

console.log("fetch account")

// return new Promise(async (resolve) => {
//   // console.log("1")
//   let gqlResult = await queryNoCache(
//     gql`
//       query User($limit: Int, $after: Int) {
//         user(limit: $limit, after: $after) {
//           # user_username
//           user_telegram
//           # tiers
//           stakes {
//             amount
//             enrolled
//             unlockedTime
//           }
//           # stakedTimestampOfLatestTier
//           # stakedDurationOfLatestTier
//           # projectFunded
//           # pspExpiry
//           # pspInfo {
//           #   isOxbTier1
//           #   isKwaiTier1
//           #   oxbPsp {
//           #     isPsp
//           #   }
//           #   kwaiPsp {
//           #     isPsp
//           #     stakePspExpiry
//           #     nftPspExpiry
//           #   }
//           # }
//         }
//       }
//     `,
//     {
//       limit: 6,
//       after: null,
//     }
//   );

//   console.log('sssssss', gqlResult["user"], userState.value);
//   accountData.value = gqlResult["user"];

//   accountData.value = $userData.value?.mongo;
//   resolve();
// });


console.log('fetch account fetch account fetch account');
return new Promise(async (resolve) => {

  console.log('fetch account fetch account fetch account', supabase);

  // const {data, error} = await supabase.from("oxb_stakes_base").select().eq("account", $address.value).maybeSingle();

  // console.log('ssssssss', userState.value, data);
  accountData.value = userState.value;
  console.log("userState.value", userState.value)

  // if(!accountData.value?.stakes) {
  //   accountData.value.stakes = {
  //     amount: 0,
  //     enrolled: false,
  //     unlockedTime: 0,
  //   }
  // } else {
  //   // accountData.value.stakes.amount = Math.floor(data.amount / 1e18 * 1e9) / 1e9;
  //   // accountData.value.stakes.enrolled = data.enrolled;
  //   // accountData.value.stakes.unlockedTime = data["start_unstake_time"];
  // }

  posthogStore.posthogRef.capture('fetch account', { 
    wallet_address: $address.value,
    userState: userState.value,
    accountData: accountData.value
  })

  resolve();
});
};


const fetchOxbBalance = async () => {
  
  let balance = await getBalance($wagmiConfig, {
    address: $address.value,
    token: OXB_V2_ADDRESS,
    // chainId: 56
    // chainId: 8453
    chainId: 8453
  });

  // console.log(balance);

  oxbBalance.value = Number(balance.value) / 1e18;
};

const listenToSupabaseChanges = async () => {
  if (!supabase) {
    supabase = createClient(supabaseUrl, supabaseKey, {
      global: {
        headers: {
          authorization: `${$accessToken.value}`,
        },
      },
    });
  }

  /// Remove existing subscriptions, if any
  try {
    // if (uqSub) supabase.removeChannel("qualificationsBASE");
    // if (luSub) supabase.removeChannel("linked");

    if( uqSub || luSub ) supabase.removeAllChannels();

    uqSub = false;
    luSub = false;
  } catch (e) {
    console.log(e);
  }

  // Establish new subscriptions
  supabase
    .channel("qualificationsBASE")
    // .on("postgres_changes", { event: "*", schema: "public", table: "user_qualifications" }, (payload) => {
    .on("postgres_changes", { event: "*", schema: "public", table: "user_qualifications_base" }, (payload) => {
      // console.log("Change received!", payload);

      qualification_data.value = payload.new;

      render();
    })
    .subscribe();

  uqSub = true;

  supabase
    .channel("linked")
    .on("postgres_changes", { event: "*", schema: "public", table: "linked_users" }, (payload) => {
      // console.log("Change received!", payload);
      // render(payload.new);
      linked_user_data.value = payload.new;
      render();
    })
    .subscribe();

  luSub = true;

  /// For first load

  // let [uq_result, lu_result] = await Promise.all([supabase.from("user_qualifications").select().eq("account", $address.value).single(), supabase.from("linked_users").select().eq("wallet_address", $address.value).single()]);
  let [uq_result, lu_result] = await Promise.all([
    supabase.from("user_qualifications_base_view").select().eq("account", $address.value).single(), 
    supabase.from("linked_users").select().eq("wallet_address", $address.value).single(),
  ]);

  console.log('aaa uq_result', uq_result, $address.value);
  console.log('aaa lu_result', lu_result);  

  // const uq_result = await supabase.from("user_qualifications").select().eq("account", walletStore.address).single();
  // const lu_result = await supabase.from("linked_user").select().eq("wallet_address", walletStore.address).single();

  qualification_data.value = uq_result?.data;
  linked_user_data.value = lu_result?.data;

  render();
};

const render = async () => {
  // If the user has linked their wallet, we don't need to show the link profile button
  // The user might linked using legacy method, so we need to check if the user has telegram username
  if (linked_user_data.value || accountData?.value.user_telegram) {
    needLinkProfile.value = false;
  } else {
    needLinkProfile.value = true;
  }

  qualification_display_list.value = [];
  group_data_display.value = [];

  console.log('aaa qualification_data.value', qualification_data.value);


  if (qualification_data.value) {
    /// Generate the qualification display list
    for (let label of Object.entries(qualification_label)) {
      if (qualification_data.value[label[0]] > 0) {
        qualification_display_list.value.push({
          label: label[1],
          key: label[0],
          value: qualification_data.value[label[0]],
        });
      }
    }

    if (qualification_data.value.oxb_psp) {
      qualification_display_list.value.push({
        label: "OXB Private Sale Pass",
        key: "oxb_psp",
        value: "Activated",
      });
    }

    /// Generate the group data display list
    for (let group of group_data) {
      if (qualification_data.value[group.keys] > 0) {
        group_data_display.value.push({
          label: group.label,
          url: group.url,
          exclusive: true,
        });
      }
    }
  }

  // let oxb_staked_eth = walletStore.stakeAmtEtherNumber
  // console.clear()
  // console.log(oxb_staked_eth);

  // if (oxb_staked_eth >= 50) {
  //   disableTier3.value = true;
  // }

  // if (!initialized.value) {
  //   initialized.value = true
  // }
  group_data_display.value.push({
    label: "Official Chat Group",
    url: "https://t.me/Oxbull_tech",
    exclusive: false,
  });

  group_data_display.value.push({
    label: "Official Announcement Channel",
    url: "https://t.me/Oxbull_tech_announcement",
    exclusive: false,
  });

  initialized.value = true;
};

let throttle = false;

const renderView = async () => {
  
  let main = async () => {
    initialized.value = false;
    accountData.value = null;
    qualification_data.value = null;
    linked_user_data.value = null;

    if ($accessToken.value) {
      
      listenToSupabaseChanges();
      await fetchAccount();
      await fetchOxbBalance();

    } else {
      console.log(4);
      initialized.value = true;
    }

    posthogStore.posthogRef.capture('Render View', { 
      wallet_address: $address.value,
      userState: userState.value
    })
  }

  if (throttle) {
    clearTimeout(throttle);
  }

  throttle = setTimeout(() => {
    main();
  }, 500);

};

const stakeForOxbTier = (amount) => {
  if ($address.value) {
    if (unstaked.value) {
      showRestakeModal.value = true;
      return;
    }

    if (disableStake.value) {
      needLinkProfile.value = true;
      return;
    } else {
      stakingModalRef.value.showModal = true;
      stakingModalRef.value.oxbStakeInput = amount;
      stakingModalRef.value.updateProgressBar();
    }
  } else {
    // alert("Link copied to clipboard");
    // toast.add({
    //   id: 'connect_wallet',
    //   title: 'Connect Wallet',
    //   description: 'Please connect your wallet to proceed',
    //   // icon: 'i-heroicons-heart-solid',
    //   timeout: 5000,
    //   ui: {
    //     strategy: 'override',
    //     icon: {
    //       "base": "flex-shrink-0 w-5 h-5 mt-0.5",
    //       "color": "text-{color}-500 dark:text-{color}-400"
    //     },
    //     background: 'bg-woodsmoke-800/50 backdrop-blur-md',
    //     container: 'border border-turquoise-500/20 relative overflow-hidden',
    //     title: 'text-turquoise-500 text-base',
    //     description: 'text-white text-sm',
    //   }
    // })

    _toast({
      id: "connect_wallet",
      title: "Connect Wallet",
      description: "Please connect your wallet to proceed",
    });
  }
};

const toggleStakingModal = () => {
  if (unstaked.value) {
    showRestakeModal.value = true;
    return;
  }

  if (disableStake.value) {
    needLinkProfile.value = true;
  } else {
    stakingModalRef.value.showModal = !stakingModalRef.value.showModal;
  }
};

// Helper functions

const get_stake_own = (i) => {
  if (!qualification_data.value) return 0;

  switch (i) {
    case 0:
      return qualification_data.value[`oxb_stake_tier1`] > 0 ? qualification_data.value[`oxb_stake_tier1`] : 0;
    case 1:
      return qualification_data.value[`oxb_stake_tier2`] > 0 ? qualification_data.value[`oxb_stake_tier2`] : 0;
    case 2:
      return qualification_data.value[`oxb_stake_tier3`] > 0 ? qualification_data.value[`oxb_stake_tier3`] : 0;
  }
};

const alreadyHaveDifferentPsp = (i) => {
  if (qualification_data.value?.oxb_psp){

    // user have a psp, but we need to check which tier is it

    if (qualification_data.value?.oxb_stake_tier2 > 0 && (i == 2)) {
      return true
    }

    if (qualification_data.value?.oxb_stake_tier3 > 0 && (i == 1)) {
      return true
    }

    
  }
  
  return false

};

const showPspActive = (i) => {
  if (i == 1) {
    if (qualification_data.value?.oxb_stake_tier2 > 0) {
      return true;
    } else {
      return false;
    }
  }

  if (i == 2) {
    if (qualification_data.value?.oxb_stake_tier3 > 0) {
      return true;
    } else {
      return false;
    }
  }
};

const unstaked = computed(() => {
  if (!accountData.value?.stakes?.enrolled && accountData.value?.stakes?.amount > 0) {
    return true;
  } else {
    return false;
  }
});

const disableTier3 = computed(() => {
  return accountData.value?.stakes?.amount >= 50;
});

const disableStake = computed(() => {
  return !(linked_user_data.value || accountData?.value.user_telegram);
});

const _splitNumberByDot = (number) => {
  let _number = number.toString();
  let _number_split = _number.split(".");
  let _number_split_0 = _number_split[0];
  let _number_split_1 = _number_split[1];

  return {
    integer: _number_split_0,
    decimal: _number_split_1,
  };
};

// Tour

const showFirstTour = ref(false);
const startTour = () => {
  const driverObj = driver({
    showProgress: true,
    overlayColor: "#0F916A",
    steps: [
      {
        popover: {
          description: "Welcome to Oxbull.tech Staking. You can gain access to contribute in IDO / Private held by Oxbull.<br><br>This is a quick tour to help you get started.",
        },
      },
      {
        element: "#staking_status",
        popover: {
          title: "Staking Status",
          description: "This is your staking status. This card here reflects your current staking status and wallet balance.",
        },
      },
      {
        element: "#staking_qualification_list",
        popover: {
          title: "Staking Qualifications",
          description: "This is the list of qualifications you own.",
        },
      },
      {
        element: "#staking_qualified_groups",
        popover: {
          title: "Telegram Groups",
          description: "This is the list of Telegram groups you can join based on your qualifications.",
        },
      },
      {
        element: "#staking_oxb_staked",
        popover: {
          title: "OXI Staked",
          description: "This is the amount of OXI tokens you have staked.",
        },
      },
      {
        element: "#staking_oxb_staked_refresh",
        popover: {
          title: "Refresh OXI Staked",
          description: "Click this button to refresh your OXI staked amount.",
        },
      },
      {
        element: "#staking_oxb_balance",
        popover: {
          title: "OXI Balance",
          description: "This is the amount of OXI tokens you have in your wallet.",
        },
      },
      {
        element: "#staking_buy_oxb",
        popover: {
          title: "Buy OXI",
          description: "Click this button to buy OXI tokens.",
        },
      },
      {
        element: "#staking_cta_button",
        popover: {
          title: "Stake OXI",
          description: "When you have sufficient OXI tokens, you can click this button to stake for a tier.",
        },
      },
      {
        element: "#oxb_stake_menu_card_1",
        popover: {
          title: "Stake OXI",
          description: "You can read information about each tier, as each tier has different requirements and benefits.",
        },
      },
      {
        element: "#stake_button_1",
        popover: {
          title: "Stake OXI",
          description: "You can click this button to stake for this tier.",
        },
      },
      {
        element: "#staking_toggle_options",
        popover: {
          title: "Show Full Options",
          description: "You can also view other full options by clicking this button.",
        },
      },
      {
        element: "#staking_medium_details",
        popover: {
          title: "Read Full Details",
          description: "The full details about staking can be found in our Medium article, you can access it here.",
        },
      },
      {
        element: "#staking_tour",
        popover: {
          title: "Launch Tour",
          description: "Anytime you want to launch this tour again, you can click this button.",
        },
      },
    ],
  });

  driverObj.drive();
};

/// Restaking block

const showRestakeModal = ref(false);

const restakeOxb = async () => {
  showRestakeModal.value = false;
  // alert("Restaking OXB");

  // Freeze the UI, and then call the contract, wait for transaction receipt, and then unfreeze the UI

  userStore.pauseUI = true;

  try {
    const result = await writeContract($wagmiConfig, {
      abi: stakeABI,
      address: STAKE_ADDRESS,
      functionName: "stake",
      args: [0],
    });

    // console.log(result);

    await waitForTransactionReceipt($wagmiConfig, {
      hash: result.hash,
      confirmations: 2, 
    });

    _toast({
      id: "restake",
      title: "Restake Complete",
      description: "Your OXI tokens have been restaked",
    });

    renderView();
  } catch (e) {
    console.log(e);
  }

  userStore.pauseUI = false;
};

const switchToBase = async () => {
  await switchChain($wagmiConfig, {
    chainId: 8453,
  });
};

// Staking Complete

const stakingCompleteModalRef = ref(null);

const showGroupTour = () => {
  const driverObj = driver({
    showProgress: true,
    overlayColor: "#0F916A",
    steps: [
      {
        element: "#staking_qualified_groups",
        popover: {
          title: "Check out your Telegram Groups",
          description: "This is the list of Telegram groups you can join based on your qualifications.",
        },
      },
    ],
  });

  driverObj.drive();
};

const stakingComplete = async (ev) => {
  // console.log("EVENT", ev);

  await fetchAccount();

  stakingModalRef.value.showModal = false;

  stakingCompleteModalRef.value.openModal({
    stake_input: ev.stake_input,
    // explorer_link: `https://bscscan.com/tx/${ev.hash}`,
    explorer_link: `https://basescan.org/tx/${ev.hash}`,
    tiers: ev.tiers,
  });

  // await listenToSupabaseChanges();
  renderView();
};
</script>

<style>
.v-popper__arrow-outer {
  display: none !important;
}

.v-popper__popper--no-positioning {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-end;
}

.v-popper__popper--no-positioning .v-popper__backdrop {
  display: block;
  background: rgba(0 0 0 / 90%);
}

.v-popper__popper--no-positioning .v-popper__wrapper {
  width: 100%;
  pointer-events: auto;
  transition: transform 0.15s ease-out;
}

.v-popper__popper--no-positioning.v-popper__popper--hidden .v-popper__wrapper {
  transform: translateY(100%);
}

.v-popper__inner {
  background: #15181e !important;
  border: none !important;
}
</style>
